<template>
  <section>
    <pdf-view />
    <h3>
      <v-icon>today</v-icon>
      Resumen de asistencias
      <v-menu open-on-hover buttom>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">help_outline</v-icon>
        </template>
        <v-card>
          <v-card-text class="warning">
            <v-layout>
              <v-flex class="text-xs-center caption">
                <strong>
                  <p><v-icon>help_outline</v-icon></p>
                  <p>Puede generar un reporte</p>
                  <p>con los atrasos y días</p>
                  <p>trabajados de uno o todos</p>
                  <p>los funcionarios en un</p>
                  <p>rango de fechas.</p>
                </strong>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-menu>
    </h3>
    <v-card>
      <v-card-text class="secondary">
        <v-form
          @submit.prevent="obtenerAsistencias()"
          v-model="valid"
          ref="form"
          lazy-validation
        >
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex md4>
                <v-autocomplete
                  :items="personas"
                  :item-text="
                    (val) =>
                      val.nombres + ' ' + val.ap_paterno + ' ' + val.ap_materno
                  "
                  :item-value="(val) => val.id"
                  :rules="form.todos ? [] : $validate(['required'])"
                  label="Seleccione un funcionario"
                  :loading="cargaFuncionarios"
                  :disabled="form.todos"
                  v-model="form.id_persona"
                  @input="bandera_genera = false"
                />
              </v-flex>
              <v-flex md2>
                <v-checkbox
                  label="Todos los funcionarios"
                  v-model="form.todos"
                ></v-checkbox>
              </v-flex>
              <v-flex md2>
                <v-text-field
                  type="date"
                  v-model="form.fecha_desde"
                  :rules="$validate(['required'])"
                  required
                  label="Fecha desde"
                  @input="bandera_genera = false"
                />
              </v-flex>
              <v-flex md2>
                <v-text-field
                  type="date"
                  v-model="form.fecha_hasta"
                  :rules="$validate(['required'])"
                  required
                  label="Fecha hasta"
                  @input="bandera_genera = false"
                />
              </v-flex>
              <v-flex md2>
                <v-btn color="blue" :loading="loading" dark block type="submit">
                  <v-icon>schedule</v-icon>
                  Generar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-text v-if="lista.length > 0" class="primary">
        <v-container grid-list-md>
          <v-layout wrap class="white--text">
            <v-flex md6>
              <p>
                <strong>Rango de fechas:</strong> {{ fechas.desde }} al
                {{ fechas.hasta }}
              </p>
            </v-flex>
            <!-- <v-flex md5>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Introduzca su busqueda por Nombre o Carnet"
                single-line
                hide-details
                dark
              ></v-text-field>
            </v-flex> -->
            <!-- <v-flex md1>
              <v-btn
                icon
                color="red"
                dark
                title="Generar reporte PDF??"
                @click.native="generarReporte()"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>
            </v-flex> -->
          </v-layout>
        </v-container>
      </v-card-text>
      <!-- Card para mostrar que no hay datos -->
      <v-card-text v-if="lista.length == 0 && bandera_genera" class="primary">
        <v-container grid-list-md>
          <v-layout wrap class="white--text">
            <v-flex></v-flex>
            <v-flex md24>
              <h1>No existen datos</h1>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-text v-if="lista.length > 0" class="primary">
        <v-data-table
          :headers="headers"
          :items="lista"
          class="elevation-1"
          hide-actions
          item-key="index"
          :search="search"
        >
          <template v-slot:items="props">
            <td class="text-xs-center">{{ props.item.nombres }}</td>
              <td class="text-xs-center">{{ props.item.unidad }}</td>
            <td class="text-xs-center">{{ props.item.dia }}</td>
            <td class="text-xs-center">{{ props.item.fecha }}</td>
            <td class="text-xs-center">{{ props.item.hora }}</td>
            <!-- <td
              :class="
                props.item.atraso > 30
                  ? 'text-xs-center warning'
                  : 'text-xs-center'
              "
            >
              {{ props.item.atraso }}
            </td> -->
           
          </template>

          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              No se encontró resultados para la busqueda "{{ search }}".
            </v-alert>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
import PdfView from "./components/PdfView.vue";

export default {
  components: { PdfView },
  mixins: [validate],
  data() {
    return {
      persona: {},
      form: {
        todos: false,
      },
      loading: false,
      valid: false,
      headers: [
       
        { text: "Nombres", value: "nombres", sortable: false, align: "center" },
                { text: "Unidad", value: "unidad", sortable: false, align: "center" },
       
        {
          text: "Día de asistencia",
          value: "dia",
          sortable: false,
          align: "center",
        },
        {
          text: "Fecha asistencia",
          value: "fecha",
          sortable: false,
          align: "center",
        },
        {
          text: "Hora de marcado",
          value: "hora",
          sortable: false,
          align: "center",
        },

        // { text: 'Gestión/Mes', sortable: false,value: 'fecha', align: 'center' },
        // { text: 'Total minutos atrasado', sortable: false,value: 'atraso', align: 'center' },
        // { text: 'Total días trabajados', sortable: false,value: 'dias_trabajados', align: 'center' }
      ],
      lista: [],
      fechas: {
        desde: "",
        hasta: "",
      },
      atrasosMin: 0,
      personas: [],
      cargaFuncionarios: false,
      search: "",
      bandera_genera: false,
    };
  },
  mounted() {
    this.persona = this.$storage.get("user");
    this.obtenerPersonas();
       var date = new Date();
      let primer_dia_mes = new Date(date.getFullYear(), date.getMonth(), 1);
      primer_dia_mes = this.$moment(primer_dia_mes).format("YYYY-MM-DD");
      let ultimo_dia_año = this.$moment().format("YYYY-MM-DD");
       this.form.fecha_desde = primer_dia_mes;
      this.form.fecha_hasta = ultimo_dia_año;
  },
  methods: {
    async obtenerAsistencias() {
      if (this.$refs.form.validate()) {
        try {
          this.loading = true;
          this.fechas.desde = this.$moment(this.form.fecha_desde).format(
            "DD/MM/YYYY"
          );
          this.fechas.hasta = this.$moment(this.form.fecha_hasta).format(
            "DD/MM/YYYY"
          );
          let res;
          if (this.form.todos) {
            res = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta: " SELECT * FROM control.fn_marcados_biometrico_sin_procesar(0, '${this.form.fecha_desde}', '${this.form.fecha_hasta}') AS (unidad TEXT , nombres TEXT, dia TEXT, fecha TEXT, hora TEXT)"){
                    respuesta
                  }
                }
              `,
            });
          } else {

            res = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta: " SELECT * FROM control.fn_marcados_biometrico_sin_procesar(${this.form.id_persona}, '${this.form.fecha_desde}', '${this.form.fecha_hasta}') AS (unidad TEXT , nombres TEXT, dia TEXT, fecha TEXT, hora TEXT)"){
                    respuesta
                  }
                }
              `,
            });
          }
          this.lista = res.runQuery.respuesta;
          this.loading = false;
          this.bandera_genera = true;
        } catch (error) {
          console.log(error);
        }
      }
    },
    async obtenerPersonas() {
      try {
        this.cargaFuncionarios = true;
        let res = await this.$service.graphql({
          query: `
            query{
                personas(l_tipo_persona:[1]){
                  rows{
                  id
                  nombres
                  ap_paterno
                  ap_materno
                  nro_doc
                  }
                }
              }
          `,
        });
        if (res.personas) {
          this.personas = res.personas.rows;
        }
        this.cargaFuncionarios = false;
      } catch (error) {
        console.log(error);
      }
    },
    sumarFechas(lista) {
      let suma = 0;
      lista.forEach((item) => {
        suma += item.atraso;
      });
      this.atrasosMin = suma;
    },
    obtenerIdPersona(ci) {
      const found = this.personas.find(
        (element) => element.nro_doc == parseInt(ci)
      );
      return parseInt(found.id);
    },
    generarReporte() {
      let url;
      if (this.form.todos) {
        // url = `http://192.168.72.253:8080/jasperserver/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=/reports/RRHH_DESARROLLO&reportUnit=/reports/RRHH_DESARROLLO/rpt_marcados_resumen&output=pdf&j_username=jasperadmin&j_password=jasperadmin&NRO_DOC=&FECHA_INI=${this.$moment(this.fechas.desde, 'DD/MM/YYYY').format('YYYY-MM-DD')}&FECHA_FIN=${this.$moment(this.fechas.hasta, 'DD/MM/YYYY').format('YYYY-MM-DD')}`
      } else {
        let url;
        let user = this.$storage.get("user");
        let nombre_reporte = "rpt_asistencia_general2";
        let formato_doc = "output=pdf";
        let nombre_carpeta = "marcados";
        let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(
          /{carpeta}/g,
          nombre_carpeta
        );
        url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;
        //Parametros
        let fecha_inicio = this.$moment(this.form.fecha_desde).format(
          "YYYY-MM-DD"
        );
        let fecha_fin = this.$moment(this.form.fecha_hasta).format(
          "YYYY-MM-DD"
        );
        let id_persona = parseInt(this.form.id_persona);
        // URL con parametros
        let url_parametros = `${url}&fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}&id_persona=${id_persona}`;

        this.$bus.$emit("reporteAsistencia", url_parametros);
      }
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/admin/asistencia/AsistenciaResumen.vue